import {
  DEFAULT_TRACK_GAIN_DB,
  type TracksStore,
  TrackType,
} from '../../../../../shared/store/tracks.store.tsx'
import type {
  AudioFormClip,
  AudioFormLayer,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { trackVolumeToGain } from './track-volume-to-gain.ts'

export const mapSoundDesignsToAudioformLayers = (
  trackStore: TracksStore
): AudioFormLayer[] => {
  const soundDesignTrack = trackStore.tracks.find(
    (track) => track.type === TrackType.SoundDesigns
  )
  const gain = trackVolumeToGain(
    soundDesignTrack?.volume ?? DEFAULT_TRACK_GAIN_DB
  )
  const soundDesigns = soundDesignTrack?.clips ?? []

  const sortedSoundDesigns = soundDesigns
    .filter(
      (clip): clip is typeof clip & { startAt: number } =>
        clip.startAt !== undefined
    )
    .sort((a, b) => a.startAt + a.startOffset - (b.startAt + b.startOffset))

  let previousEnding = 0

  const soundDesignClips: AudioFormClip[] = sortedSoundDesigns.flatMap((sd) => {
    const marginStart = sd.startAt + sd.startOffset - previousEnding
    previousEnding = sd.startAt + sd.duration + sd.endOffset

    return [
      {
        assetRef: sd.id,
        ...(sd.fadeIn > 0 && { fadeIn: sd.fadeIn }),
        ...(sd.fadeOut > 0 && { fadeOut: sd.fadeOut }),
        ...(sd.startOffset > 0 && { readPosition: sd.startOffset }),
        forcedDuration: sd.duration - sd.startOffset + sd.endOffset,
        marginStart: Math.max(marginStart, 0), // to avoid infinitesimal negative values
        gain,
      },
    ]
  })

  return [{ clips: soundDesignClips }]
}
